// partner bao gồm customer và partner
export default [
  {
    name: 'companySetting',
    label: 'labels.settings',
    permissionKey: 'company_setting',
    children: [
      {
        name: 'generalSetting',
        label: 'labels.generalSetting',
        permissionKey: 'general_setting'
      },
      {
        name: 'companyGroup',
        label: 'labels.companyGroupManagement',
        permissionKey: 'company_group_management',
        children: [
          {
            name: 'company_group_add',
            label: 'labels.companyGroupAdd',
            permissionKey: 'company_group_add'
          },
          {
            name: 'company_group_edit',
            label: 'labels.companyGroupEdit',
            permissionKey: 'company_group_edit'
          },
          {
            name: 'company_group_update_permissions',
            label: 'labels.companyGroupUpdatePermissions',
            permissionKey: 'company_group_update_permissions'
          },
          {
            name: 'company_group_delete',
            label: 'labels.companyGroupDelete',
            permissionKey: 'company_group_delete'
          },
          {
            name: 'company_group_archive',
            label: 'labels.companyGroupArchive',
            permissionKey: 'company_group_archive'
          }
        ]
      },
      {
        name: 'companyUser',
        label: 'labels.companyUserManagement',
        permissionKey: 'company_user_management',
        children: [
          {
            name: 'company_user_edit',
            label: 'labels.companyUserEdit',
            permissionKey: 'company_user_edit'
          },
          {
            name: 'company_user_add',
            label: 'labels.companyUserAdd',
            permissionKey: 'company_user_add'
          },
          {
            name: 'company_user_delete',
            label: 'labels.companyUserDelete',
            permissionKey: 'company_user_delete'
          },
          {
            name: 'company_user_archive',
            label: 'labels.companyUserArchive',
            permissionKey: 'company_user_archive'
          }
        ]
      }
    ]
  },
  {
    name: 'order_management',
    label: 'labels.orderManagement',
    permissionKey: 'order_management'
  },
  {
    name: 'trip_management',
    label: 'labels.tripManagement',
    permissionKey: 'trip_management'
  },
  {
    name: 'journey_management',
    label: 'labels.journeyManagement',
    permissionKey: 'journey_management'
  },
  {
    name: 'journey_schedule_management',
    label: 'labels.scheduleManagement',
    permissionKey: 'journey_schedule_management'
  },
  {
    name: 'driver_sync_app_mobile',
    label: 'labels.driverSyncAppMobile',
    permissionKey: 'driver_sync_app_mobile'
  },
  {
    name: 'sellingPriceManagement',
    label: 'labels.sellingPriceManagement',
    permissionKey: 'selling_price_management',
    children: [
      {
        name: 'sellingPriceAdd',
        label: 'labels.sellingPriceAdd',
        permissionKey: 'selling_price_add'
      },
      {
        name: 'sellingPriceEdit',
        label: 'labels.sellingPriceEdit',
        permissionKey: 'selling_price_edit'
      },
      {
        name: 'sellingPriceDelete',
        label: 'labels.sellingPriceDelete',
        permissionKey: 'selling_price_delete'
      },
      {
        name: 'sellingPriceArchive',
        label: 'labels.sellingPriceArchive',
        permissionKey: 'selling_price_archive'
      }
    ]
  }
]
